// extracted by mini-css-extract-plugin
export default {"root":"InterviewbitTestDuration_root__4tuyY"};